import { Card } from "@mantine/core";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { Calendar, DateObject } from "react-multi-date-picker";
import "./style.css";

type Props = {
  close: () => void;
  setDate: (e: Date) => void;
  minDate?: boolean;
};

function SelectFromCalendar({ close, setDate, minDate }: Props) {
  const selectDate = (date: DateObject) => {
    setDate(new Date(date.valueOf()));
    close();
  };
  return (
    <Card withBorder>
      <Calendar
        className="custom-container"
        calendar={persian}
        locale={persian_fa}
        onChange={selectDate}
        minDate={minDate ? new Date() : undefined}
      />
    </Card>
  );
}

export default SelectFromCalendar;
